import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/tumblr-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM317.7 396.2c2.3-2.4 1.3-5.9 0.3-9.1l-13.8-40.2c-1-2.8-2.4-4.4-4.6-4.9-2.4-0.6-5 0.2-8 1.4-27.7 11.1-42.5-1-42.5-22.4v-83.3h52.1c3.4 0 6.2-2.8 6.2-6.2v-51.1c0-3.4-2.8-6.2-6.2-6.2h-51.9v-72c0-3.4-2.8-6.2-6.2-6.2h-44.3c-5.9 0-9.5 3.3-10 10.2-1.8 25.7-13.9 59.5-52.7 73.2-4.3 1.5-7.1 5.5-7.1 10v42.5c0 3.4 2.8 6.2 6.2 6.2h29.7v90c0 32.4 16.4 87.9 91.9 87.9 29.7 0 52.4-10.7 60.9-19.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/tumblr-square.js
// module id = 1060
// module chunks = 0